import axios from "./axios";

/**
 * API Service layer
 * - handles endpoint configuration (headers and methods)
 * - abstracts api calls so the app doesn't have to know the hows of api requests
 * - allows for ease of changing the functionality of api calls without having to find duplicate code
 *
 * Note: Authorization headers are injected automatically by the axios request interceptor
 * via the auth cookie. There is no need to pass an access token to these methods.
 */

async function sendAPIRequest(url, method, headers = {}, data = null) {
  const response = await axios({
    method: method,
    url: url,
    baseURL: process.env.REACT_APP_API_URL
      ? process.env.REACT_APP_API_URL
      : "https://api.healthnsync.com",
    headers,
    data,
  });
  return await response.data;
}

const ApiServices = {
  getData: async (url) => {
    return await sendAPIRequest(url, "GET", { "Content-Type": "application/json" });
  },
  postData: async function postDataRequest(url, data) {
    return await sendAPIRequest(url, "POST", { "Content-Type": "application/json" }, data);
  },
  putData: async function putDataRequest(url, data) {
    return await sendAPIRequest(url, "PUT", { "Content-Type": "application/json" }, data);
  },
  patchData: async function patchDataRequest(url, data) {
    return await sendAPIRequest(url, "PATCH", { "Content-Type": "application/json" }, data);
  },
  deleteData: async function deleteDataRequest(url) {
    return await sendAPIRequest(url, "DELETE", { "Content-Type": "application/json" });
  },
  optionsData: async (url) => {
    return await sendAPIRequest(url, "OPTIONS");
  },
};

export default ApiServices;
